define('modules/accounts/companies/detail/view',['require','exports','module','lodash','jquery','i18n','views/BaseView','views/AlertView','base/model','./form-company-view','./form-company-services-view','env','./../../../private/view-mdsidebar','./../modal/view','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var _ = require("lodash");
  var $ = require("jquery");
  var i18n = require("i18n");
  var BaseView = require("views/BaseView");
  var AlertView = require("views/AlertView");
  var BaseModel = require("base/model");
  var FormCompanyView = require("./form-company-view");
  var FormCompanyServicesView = require("./form-company-services-view");
  var Config = require("env");
  var MDSidebarJS = require("./../../../private/view-mdsidebar");

  var ModalCompanyView = require("./../modal/view");

  var scrollTop = function () {
    $("html,body").scrollTop(0);
  };

  var View = BaseView.extend({
    template: require("ldsh!./template"),

    alertView: null,

    events: {
      "change #country": "getProvinces",
      "click #expandAccountServices": "expandAccountServices",
      "click #activate-service-switch": "validateLimitsServices",
      "click #cancelFormCompany": "goBack",
    },

    goBack: function () {
      var MyApp = new Backbone.Router();
      MyApp.navigate("accounts/companies", { trigger: true });
    },

    getDataForService: function (serviceId) {
      var services = this.group.get("services"),
        dataLimitsService;
      _.each(services, function (service) {
        if (service.id == serviceId) {
          dataLimitsService = service;
        }
      });
      return dataLimitsService;
    },

    expandAccountServices: function (event) {
      scrollTop();
      var serviceId = $(event.currentTarget).attr("data-serviceId");
      if (serviceId == 2 || serviceId == 1) {
        location.href = Config.paymentsUrl + "account/products";
      }
    },

    renderModalServices: function (serviceId, dataLimitsService) {
      var modalview = new ModalCompanyView({
        me: this.me,
        serviceId: serviceId,
        dataLimitsService: dataLimitsService,
      });
      $("#renderModalServices").html(modalview.render().el);
    },

    updateLimitServices: function (serviceId) {
      var services = this.group.get("services");
      _.each(services, function (service) {
        if (service.id == serviceId) {
          service.numCompanies = service.numCompanies - 1;
        }
      });
      this.group.set({ services: services });
    },

    validateLimitsServices: function (event) {
      var serviceId = $(event.currentTarget).attr("data-serviceId");
      var dataLimitsService = this.getDataForService(serviceId);

      if (dataLimitsService.numCompanies < dataLimitsService.maxCompanies) {
        this.activateService(event, serviceId);
      } else if (
        dataLimitsService.numCompanies == dataLimitsService.maxCompanies &&
        $(event.currentTarget).hasClass("checked")
      ) {
        this.updateLimitServices(serviceId);
        this.activateService(event, serviceId);
      } else {
        this.renderModalServices(serviceId, dataLimitsService);
        $("#modalLimitService").modal("show");
      }
    },

    activateService: function (event, serviceId) {
      if ($(event.currentTarget).hasClass("checked")) {
        $(event.currentTarget).removeClass("checked");
        $("#activate-service-label_" + serviceId).html(
          $.i18n.t("ACCOUNTS.COMPANIES.LBL_DESACTIVATE_SERVICE")
        );
        this.changeStatusService(serviceId, 0);
      } else {
        $(event.currentTarget).addClass("checked");
        $("#activate-service-label_" + serviceId).html(
          $.i18n.t("ACCOUNTS.COMPANIES.LBL_ACTIVATE_SERVICE")
        );
        this.changeStatusService(serviceId, 1);
      }
    },

    changeStatusService: function (serviceId, valueStatusService) {
      var services = this.model.get("services");
      _.each(services, function (service) {
        if (service.id == serviceId) {
          service.activeServiceCompany = valueStatusService;
        }
      });
      this.model.set({ services: services });
    },

    initialize: function () {
      var self = this;
      this.alertView = null;
      if (this.model) {
        this.listenTo(this.model, "reset sync request error", function () {
          self.render();
          if (self.alertView) {
            $("#messages-container").append(self.alertView.render().el);
          }
        });
      }
    },

    beforeRender: function () {
      var self = this;
      this.insertView(
        "#form-company",
        new FormCompanyView({
          model: this.model,
          groupId: this.options.group.id,
        })
      );

      if (this.model.get("id")) {
        _.each(this.model.get("services"), function (service) {
          self.insertView(
            "#form-company-services",
            new FormCompanyServicesView({
              model: new BaseModel(service),
              group: self.options.group.get("services")[service.id],
            })
          );
        });
      }
    },

    afterRender: function () {
      BaseView.prototype.afterRender.call(this);
      var companyData = this.serialize().company.attributes;

      this.getCountries(
        companyData.country,
        companyData.province,
        companyData.timezone
      );

      $("#timezone").val(companyData.timezone);

      if (typeof companyData.sector != "undefined") {
        $("#sector").val(companyData.sector);
      }

      $("select").select2({
        style: "border: 3px solid black;",
      });

      var self = this;
      $("#messages-container").html("");

      if (!this.model.get("id")) {
        $("#accounts-service-content").hide();
      }

      $("#form-accounts-companys-detail")
        .bootstrapValidator({
          onSuccess: function (e) {
            self.save();
          },
          onError: function (e) {
            var alert = new AlertView({
              el: "#messages-container",
              type: "danger",
              msg: "ACCOUNTS.COMPANIES.MSG_VALIDATION_ERR",
            });
            alert.render();
            scrollTop();
          },
          feedbackIcons: {
            valid: "fa fa-check",
            invalid: "fa fa-exclamation",
            validating: "fa fa-spinner",
          },
        })
        .on("error.field.bv", function (e, data) {
          var that = $(e.target);
        });
    },

    setTimeZone: function (selectedTimezone) {
      var selected = $("#country").find("option:selected");
      var zone = selected.data("timezone");

      if (selectedTimezone) {
        zone = selectedTimezone;
      }

      $("#timezone").val(zone);
      $("#timezone").select2().select2("val", zone);

      return false;
    },

    getCountries: function (country, province, timezone) {
      var self = this;
      $("#submitButton").prop("disabled", true);

      $.ajax({
        type: "GET",
        url: Config.getCountriesUrl,
        dataType: "json",
      }).done(function (data) {
        self.addCountries(
          data._embedded.countries,
          country,
          province,
          timezone
        );
      });
    },

    getProvinces: function (selectedProvince, selectedTimezone) {
      var self = this;

      $("#submitButton").prop("disabled", true);
      self.setTimeZone();

      $.ajax({
        type: "GET",
        url: Config.getProvincesUrl + $("#country").val(),
        dataType: "json",
      }).done(function (data) {
        self.addProvinces(
          data._embedded.provinces,
          selectedProvince,
          selectedTimezone
        );
      });
    },

    addCountries: function (
      countries,
      selectedCountry,
      selectedProvince,
      timezone
    ) {
      var self = this;
      var lang = this.getLangForCountries();

      $.each(countries, function (index, country) {
        $("#country").append(
          "<option value='" +
            country.id +
            "' data-timezone='" +
            country.timezone +
            "'>" +
            country.name[lang] +
            "</option>"
        );
      });

      if (selectedCountry) {
        $("#country").val(selectedCountry);
        $("#country").select2().select2("val", selectedCountry);
      } else {
        $("#country").val("ES");
        $("#country").select2().select2("val", "ES");
      }

      self.getProvinces(selectedProvince, timezone);
    },

    addProvinces: function (provinces, selectedProvince, selectedTimezone) {
      $("#province").find("option").remove();
      $("#province").append(
        "<option value=''>" +
          $.i18n.t("PUBLIC.FIRSTSTEP.LBL_SELECT_A_PROVINCE") +
          "</option>"
      );
      this.desactivateValidationProvince();

      $.each(provinces, function (index, province) {
        $("#province").append(
          "<option value='" + province.id + "'>" + province.name + "</option>"
        );
        $("#province").attr("data-bv-notempty", true);
        $("#form-accounts-companys-detail").bootstrapValidator(
          "addField",
          "province"
        );
      });
      if (
        typeof selectedProvince === "undefined" ||
        (selectedProvince && selectedProvince.type === "change")
      ) {
        $("#province").val("");
        $("#province").select2().select2("val", "");
      } else {
        $("#province").val(selectedProvince);
        $("#province").select2().select2("val", selectedProvince);
      }
      $("#submitButton").prop("disabled", false);
      this.setTimeZone(selectedTimezone);
    },

    serialize: function () {
      return {
        company: this.model,
        group: this.group,
      };
    },

    save: function () {
      var self = this;
      var form = $("#form-accounts-companys-detail");
      var data = {};

      form.serializeArray().map(function (item) {
        data[item.name] = item.value;
      });

      _.each(this.model.get("services"), function (service) {
        _.each(service.companies, function (company) {
          var id = service.id + "-" + company.id;
          company.active = data[id] === "on";
          if (data[id]) {
            delete data[id];
          }
        });
      });

      this.model.set(data);
      scrollTop();

      this.model.save(null, {
        success: function (model, response) {
          var message;
          if (self.model.isNew()) {
            message = "ACCOUNTS.COMPANIES.MSG_CREATED_OK";
          } else {
            message = "ACCOUNTS.COMPANIES.MSG_OK";
          }
          self.alertView = new AlertView({
            type: "success",
            msg_lang: $.i18n.t(message, {
              mdirector_app_link:
                Config.mdirectorUrl +
                "/private?redirect=preferences" +
                Config.getCompanyIdForUrl("&"),
            }),
          });
          new MDSidebarJS({
            model: self.me,
            el: "#md__sidebar__wrapper",
          }).loadServices();
        },
        error: function (model, response) {
          console.log(response);
          if (
            response &&
            response.responseJSON &&
            response.responseJSON.detail === "Invalid Web"
          ) {
            self.showAPIInvalidWebError();
          }
        },
        wait: true,
      });
    },

    showAPIInvalidWebError: function () {
      this.alertView = new AlertView({
        type: "danger",
        msg: "FORM.VALIDATION.TXT_URL",
      });
    },

    desactivateValidationProvince: function () {
      $("#provinceErrorContainer").html("");
      $("#province-form-group").removeClass("has-error");

      $("#province").attr("data-bv-notempty", false);
      $("#form-accounts-companys-detail").bootstrapValidator(
        "removeField",
        "province"
      );
    },

    getLangForCountries: function () {
      var lang = i18n.lng();
      lang = lang.substring(0, 2);
      lang = lang.toUpperCase();
      return lang;
    },
  });

  module.exports = View;
});

